export default __webpack_public_path__ + "static/media/xampp.9a4aa5dd.svg";